import styled from 'styled-components';

import Button from 'src/app/components/Elements/Button';

export const HeaderText = styled.h1`
  text-align: left;
  font-size: ${props => props.theme.fontSizes.displayXL} !important;
  padding: 0 !important;
  margin: 0 !important;

  ${props => props.theme.mediaQueries.medium} {
    font-size: ${props => props.theme.fontSizes.displayXXXL} !important;
  }
`;

export const CityName = styled.h3`
  font-size: ${props => props.theme.fontSizes.headerOne} !important;
  margin: 0 !important;
  padding: 0 !important;

  ${props => props.theme.mediaQueries.medium} {
    font-size: ${props => props.theme.fontSizes.displayXL} !important;
  }
`;

export const Locale = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.capsuleGray10};
  padding-top: ${props => props.theme.space['3.7']};
  padding-bottom: ${props => props.theme.space['3.3']};
  margin: 0 auto;

  ${props => props.theme.mediaQueries.small} {
    display: flex;
    align-items: normal;
    flex-flow: row-reverse nowrap;
    justify-content: space-between;
    width: 100%;
  }
`;

export const LocaleCityInfo = styled.div`
  margin: ${props => props.theme.space['3.314']} 0 0 !important;
  padding: 0 !important;

  ${props => props.theme.mediaQueries.small} {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
`;

export const LocaleText = styled.div<{ first?: boolean }>`
  display: flex;
  align-items: flex-start;
  margin-top: ${props => (props.first ? props.theme.space['2.7'] : props.theme.space['2.086'])};

  span {
    font-size: ${props => props.theme.fontSizes.body};
  }

  ${props => props.theme.mediaQueries.small} {
    padding-top: 0;
    margin-top: ${props => (props.first ? props.theme.space['3.6'] : props.theme.space['2.086'])};
  }
`;

export const Marker = styled.div`
  display: inline-block;
  padding-top: ${props => props.theme.space['0.3']};
  margin-right: ${props => props.theme.space['1.4']};

  i {
    width: ${props => props.theme.space['1.4']};
    height: ${props => props.theme.space['1.8']};
  }

  ${props => props.theme.mediaQueries.medium} {
    i {
      width: ${props => props.theme.space['1.8']};
      height: ${props => props.theme.space['2.365']};
    }
  }
`;

export const Phone = styled.div`
  display: inline-block;
  padding-top: ${props => props.theme.space['0.3']};
  margin-right: ${props => props.theme.space.s3};

  i {
    width: ${props => props.theme.space.s4};
    height: ${props => props.theme.space.s4};
  }

  ${props => props.theme.mediaQueries.medium} {
    i {
      width: ${props => props.theme.space['2.0']};
      height: ${props => props.theme.space['2.0']};
    }
  }
`;

export const TextLink = styled.a`
  color: ${props => props.theme.colors.capsuleBlue50} !important;
  font-size: ${props => props.theme.fontSizes.body};
`;

export const Skyline = styled.img`
  background-color: ${props => props.theme.colors.capsuleGray00};
  flex-basis: 100%;
  height: 100%;
  width: 100%;

  ${props => props.theme.mediaQueries.small} {
    background-color: transparent;
  }
`;

export const AddToWaitListWrapper = styled.div`
  width: 100%;
  margin: ${props => props.theme.space['5.2']} auto;
  background-color: ${props => props.theme.colors.capsuleGreen00};
  padding: 0 ${props => props.theme.space['4.0']};

  ${props => props.theme.mediaQueries.small} {
    margin: ${props => props.theme.space['12.9']} 0;
    padding: 0 ${props => props.theme.space['10.0']};
  }
`;

export const AddToWaitList = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  background: #eff5f5 url('/public/AddToWaitList-Mobile.svg') no-repeat;
  background-size: contain;
  background-position: center bottom;
  padding: ${props => props.theme.space['4.6']} 0 ${props => props.theme.space['24.9']};
  margin: 0 auto !important;

  ${props => props.theme.mediaQueries.small} {
    background: #eff5f5 url('/public/AddToWaitList.svg') no-repeat;
    background-size: contain;
    background-position: center bottom;
    padding: ${props => props.theme.space['4.0']} 0 ${props => props.theme.space['24.0']};
  }

  ${props => props.theme.mediaQueries.extraLarge} {
    padding-top: ${props => props.theme.space['6.0']};
    max-width: 93.8rem;
  }
`;

export const WaitListContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h3 {
    font-size: ${props => props.theme.fontSizes.headerTwo};
    margin-bottom: 0;
    padding-bottom: 0;
    padding-top: 0 !important;
  }

  ${props => props.theme.mediaQueries.small} {
    margin-top: ${props => props.theme.space['5.0']};

    h3 {
      font-size: ${props => props.theme.fontSizes.displayXL};
    }
  }
`;

export const WaitListText = styled.div`
  margin-top: ${props => props.theme.space.s3};
  text-align: center;

  p {
    margin-bottom: 0 !important;
  }

  ${props => props.theme.mediaQueries.small} {
    p {
      display: inline-block;
    }
  }
`;

export const FormContent = styled.div`
  padding-top: ${props => props.theme.space['3.0']};
  width: 100%;
  max-width: ${props => props.theme.space['30']};

  ${props => props.theme.mediaQueries.small} {
    padding-top: ${props => props.theme.space['3.0']};
  }
`;

export const JoinWaitlistButton = styled(Button)<{ background: string }>`
  margin: 0 auto;
  font-family: ${props => props.theme.fonts.mercury};
  text-transform: uppercase;
  background-color: transparent !important;
  color: ${props => (props.background === 'dark' ? props.theme.colors.white : props.theme.colors.capsuleBlue50)};
  border: 1px solid
    ${props => (props.background === 'dark' ? props.theme.colors.white : props.theme.colors.capsuleBlue50)};

  &:hover {
    background-color: ${props =>
      props.background === 'dark' ? props.theme.colors.white : props.theme.colors.capsuleBlue50};
    color: ${props => (props.background === 'dark' ? props.theme.colors.capsuleBlue50 : props.theme.colors.white)};
  }
`;

export const InputWrapper = styled.div`
  margin-bottom: ${props => props.theme.space['0.6']};
`;

export const WaitlistButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: ${props => props.theme.space['3.3']};

  ${props => props.theme.mediaQueries.small} {
    margin-top: ${props => props.theme.space['4.1']};
  }
`;

export const SVGCloseWrapper = styled.a`
  position: absolute;
  top: ${props => props.theme.space.s3};
  right: ${props => props.theme.space.s3};

  svg {
    width: ${props => props.theme.space.s3};
    height: ${props => props.theme.space.s3};
  }

  ${props => props.theme.mediaQueries.small} {
    top: ${props => props.theme.space['0.5']};
    right: ${props => props.theme.space['0.7']};
  }
`;

export const SuccessBannerWrapper = styled.div`
  ${props => props.theme.mediaQueries.small} {
    margin-bottom: ${props => props.theme.space['12.2']};
  }
`;

export const SuccessBanner = styled.div`
  margin-top: ${props => props.theme.space['3.3']};
  background-color: #dfecea;
  width: 100%;
  padding: ${props => props.theme.space['2.5']} ${props => props.theme.space['2.0']};
  display: flex;
`;

export const SuccessMessage = styled.div`
  margin: 0 auto;

  p {
    text-align: left;
    margin-bottom: 0 !important;
  }

  ${props => props.theme.mediaQueries.small} {
    p {
      display: inline-block;
    }
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: ${props => props.theme.space['3.0']};
`;
